import React, { useEffect, useState } from 'react'
import EventDetailsHeader from './EventDetailsHeader/EventDetailsHeader'
import EventDetailsBody from './EventDetailsBody/EventDetailsBody'
import { Col, Grid, Row } from '@vds/grids';
import './EventDetailsPage.scss'
import { ButtonGroup } from '@vds/buttons';
import { getImageToBeRendered, getWithExpiry, mapTopicsAndTags, TAG_RECORDED_EVENTS } from '../../utility/utils';
import { contentClick, pageLoad_Started, pageLoadStarted, pageLoadCompleted,Register_Event } from '../../common/Analytics/GAWrapper';
import { useTranslation } from 'react-i18next';

const EventDetailsPage = ({ isInPersonEvent,currentInPersonEvent, aemOffersContentForHeading, allIPEventsWithTimezone, eventStatus, selectedTopics, topicEnEsMaping, allCourses, allQuickTips, allEventsWithTimeZone, courseType, allPastEvents,eventCxAemData, offersMock, currentEvent}) => {
  let {isBefore, isAfter, isDuring} = eventStatus;
  const { t } = useTranslation();
  const [signInLinkMod, setSignInLinkMod] = useState('');
  const lng = localStorage.getItem("lng") ?? 'en';
  let justAdded = false;
  const formattedCurrentEvent = isInPersonEvent ? allIPEventsWithTimezone?.filter(item => item.id === currentEvent?.id)?.[0] ?? allPastEvents?.filter(item => item.id === currentEvent?.id)?.[0] : allEventsWithTimeZone?.filter(item => item.id === currentEvent?.id)?.[0] ?? allPastEvents?.filter(item => item.id === currentEvent?.id)?.[0];
  const [headerIcons, setHeaderIcons] = useState([]);
  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
  }
  const enrollmentDeadline = currentEvent?.enrollmentDeadline; // Get the enrollment deadline
  const isEnrollmentDeadlinePassed = enrollmentDeadline && new Date(enrollmentDeadline) < new Date(); // Check if the deadline has passed
  const isVirtual = currentEvent?.modules?.[0]?.format === "Virtual Classroom";
  const isRecorded = (currentEvent?.tags?.includes(TAG_RECORDED_EVENTS) && currentEvent?.modules?.some(module => module?.format === "VIDEO"));
  const dateStart = currentEvent?.startDate || currentEvent?.dateStart; // Get the event start date
  const completionDeadline = currentEvent?.completionDeadline; // Get the completion deadline
  let skillLvl = currentEvent?.skills?.[0]?.level ?? "";
  let skillCategory = currentEvent?.skills?.[0]?.name ?? "";
  let eventAdmissionCost = currentEvent?.localizeData?.[0]?.pricingInfo?.cost;
  let formattedAdmissionCost = eventAdmissionCost && eventAdmissionCost.toString().trim().toLowerCase() !== "free" ? t("paid") : t("free");
   let courseTitleEnEs =currentEvent?.title;
  currentEvent?.localizeData?.map((item)=>{
     if(lng=='es' && item?.locale=='es-ES'){
      courseTitleEnEs=item?.name;
     }
  })

  // Calculate if the event is ended
 const isEventEnded = (() => {
  if (completionDeadline) {
    return new Date(completionDeadline) < new Date(); // Check if the completion deadline has passed
  }
  if (!enrollmentDeadline && !completionDeadline && dateStart) {
    const endDate = new Date(dateStart).getTime() + currentEvent?.duration * 1000; // Calculate end date based on dateStart and duration
    return endDate < Date.now(); // Check if the event is ended based on endDate
  }
  return false; 
})();

  // useEffect(() => {
  //      if (!currentEvent || !eventCxAemData) return;
  //      let updatedTopics = mapTopicsAndTags(currentEvent,eventCxAemData); 
     
  //      pageLoadStarted(
  //        courseTitleEnEs,
  //        window.location.origin + localStorage.getItem("prevUrl"),
  //        updatedTopics,
  //      );
     
  //      pageLoadCompleted();
  //    }, []);// run this ga event only once 

  useEffect(() => {
    const runAsync = async () => {
    let filteredSkillIcon=[];
    let skill_Type='';
    let filteredJustAddedIcon;
    let filteredEventIcon;
    let admissionDetailIcon;
    let currentDate = Date.now();
      const dateDiff = (currentDate - new Date(currentEvent?.datePublished)) / (1000 * 60 * 60 * 24);

      const startDate = currentEvent?.dateStart;
      // Determine if the event is "Just Added"
      const justAdded = isInPersonEvent
        ? dateDiff <= 14 && startDate - currentDate >= 6 * 24 * 60 * 60 * 1000 // In-person event condition
        : dateDiff <= 14 && dateDiff >= 0; // Virtual event condition

  // Process Skill Level Icons
    currentEvent?.skills?.map(({ name, level }) => {
      const match = eventCxAemData?.skilldetails?.details?.find(detail => {
        const [skillType, skillLevel] = detail?.key.split(":");
        if(skillLevel == level){
          filteredSkillIcon.push(detail);
          if(name=='All' && skillType=='All'){
            skill_Type=skillType;
            filteredSkillIcon.length=0;
            filteredSkillIcon.push(detail);
          }  
        }
      });
    });

    if (justAdded) { filteredJustAddedIcon = eventCxAemData?.bannericons?.find(icon => icon.key === 'justadded') };
      const skillImg=await getImageToBeRendered('','','skillimg','','',filteredSkillIcon?.[0]?.imgPath,'','insScmIcon');
  // Handle In-Person Events       
  if (isInPersonEvent && eventCxAemData) {
    // Process Event Icon for In-Person Events
    const eventType = currentEvent?.modules?.[0].format === "Classroom" ? 'location' : null;
    if (eventType) {
      filteredEventIcon = eventCxAemData?.bannericons?.find(icon => icon?.key === eventType);
    }

    // Determine Admission Icon for In-Person Events
    const feeType = !currentEvent?.localizeData?.[0]?.pricingInfo?.cost ||  currentEvent?.localizeData?.[0]?.pricingInfo?.cost === 'Free' ||  currentEvent?.localizeData?.[0]?.pricingInfo?.cost === null ? 'free'  : 'cost';
    if (feeType) {
      admissionDetailIcon = eventCxAemData?.admission?.details?.find(detail => detail?.key === feeType);
    }

    // Update Header Icons for In-Person Events
    setHeaderIcons([
      filteredSkillIcon?.[0]
        ? {
            id: 1,
            // name: `${global.config.AEM_API_BASE_PATH}${filteredSkillIcon?.[0]?.imgPath}`,
            name : skillImg,
            text: `${eventCxAemData?.skilldetails?.label}${filteredSkillIcon?.[0]?.skillName}`,
          }
        : null,
      filteredEventIcon
        ? { id: 2, name: filteredEventIcon?.icon, text: filteredEventIcon?.iconlabel }
        : null,
      admissionDetailIcon
        ? { id: 3, name: admissionDetailIcon?.icon,text: `${admissionDetailIcon?.label} ${admissionDetailIcon?.value}`}
        : null,
      justAdded
        ? { id: 4, name: filteredJustAddedIcon?.icon, text: filteredJustAddedIcon?.iconlabel }
        : null,
    ].filter(Boolean));
  } else {
    // Handle Virtual or Recorded Events
    setHeaderIcons([
        filteredSkillIcon?.[0] ? { id: 1, name: `${skillImg}`, text: `${eventCxAemData?.skilldetails?.label}${filteredSkillIcon?.[0]?.skillName}` } : null,
        (isVirtual || isRecorded) ? { id: 2, name: `${isVirtual ? eventCxAemData?.bannericons[2]?.["icon"] : (isRecorded ? eventCxAemData?.bannericons[3]?.["icon"] : "")}`, text: `${isVirtual ? eventCxAemData?.bannericons[2]?.["iconlabel"] : (isRecorded ? eventCxAemData?.bannericons[3]?.["iconlabel"] : "")}` } : null,
        justAdded ? { id: 3, name: filteredJustAddedIcon?.icon, text: filteredJustAddedIcon?.iconlabel } : null

    ]);
  }
    };
    runAsync();
  }, [isVirtual, isRecorded, isInPersonEvent, eventCxAemData]);

  useEffect(() => {
    if (!isEnrollmentDeadlinePassed && !isEventEnded) {
      const bannerText = document?.getElementById('reg-banner-text') ?? null;
      if (bannerText) {
        bannerText.innerHTML = eventCxAemData?.regBannerButtons?.registerCourseText;
      }
  
      if (window?.location?.search?.includes('utm_')) {
        const utmUrl = `${window?.location?.search?.substring(1)}`;
        localStorage.setItem('utmUrl', utmUrl);
        setSignInLinkMod(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}&${utmUrl}`);
      } else {
        if (localStorage.getItem('utmUrl')) {
          setSignInLinkMod(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}&${localStorage.getItem('utmUrl')}`);
        } else {
          setSignInLinkMod(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}`);
        }
      }
    }
  }, [isEnrollmentDeadlinePassed, currentEvent, eventCxAemData,isEventEnded]);

  useEffect(() => {
    if (isInPersonEvent && !isEventEnded && !isEnrollmentDeadlinePassed) {
      const bannerText = document?.getElementById('reg-banner-text') ?? null;
      if (bannerText) {
        bannerText.innerHTML = eventCxAemData?.regBannerButtons?.registerCourseText;
      }
  
      if (window?.location?.search?.includes('utm_')) {
        const utmUrl = `${window?.location?.search?.substring(1)}`;
        localStorage.setItem('utmUrl', utmUrl);
        setSignInLinkMod(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}&${utmUrl}`);
      } else {
        if (localStorage.getItem('utmUrl')) {
          setSignInLinkMod(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}&${localStorage.getItem('utmUrl')}`);
        } else {
          setSignInLinkMod(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}`);
        }
      }
    }
  }, [isInPersonEvent,isEnrollmentDeadlinePassed, currentEvent, eventCxAemData,isEventEnded]);

    useEffect(() => { 
     if (!currentEvent || !eventCxAemData) return;
    // Get the current language
    const lng = localStorage.getItem("lng") ?? "en";
    const isSpanish = lng === "es";
  
     // Derive allTopicsData from eventCxAemData
    const allTopicsData = Array.isArray(eventCxAemData?.allTopics?.allTopicsData) ? eventCxAemData?.allTopics?.allTopicsData?.map((item) =>
      item?.label?.toLowerCase()?.split(" ")?.join("")
    ) : [];
    const rawTags = Array.isArray(currentEvent?.tags) ? currentEvent?.tags : [];
    // Translate and filter topics
    const filteredTopics = rawTags?.map((tag) => {
        // Translate the tag if Spanish is selected
        const mapping = Array.isArray(topicEnEsMaping) 
        ? topicEnEsMaping?.find((m) => m?.[1] === tag) : null;

        const translatedTag = isSpanish && mapping ? mapping?.[2] : tag;
        // Normalize the translated tag
        const normalizedTag = typeof translatedTag === "string" ? translatedTag?.replace(/\s+/g, "")?.toLowerCase() : null;
  
        // Check if the normalized tag exists in allTopicsData
        return  normalizedTag && allTopicsData?.includes(normalizedTag) ? translatedTag : null;
      })
      ?.filter(Boolean) // Remove null or undefined values
      ?.slice(0, 3) // Limit to a maximum of 3 topics
       const isConententCategory =isInPersonEvent ? `${t("Events")}: ${t("In-Person Events")}`: `${t("Events")}: ${t("Virtual Event")}`;
       const admissionCost = isInPersonEvent ? getPaidStatus(currentEvent?.localizeData?.[0]?.pricingInfo?.cost) : t("free");
       const level = currentEvent?.skills?.[0]?.level ?? "";
       const event_skill_levelCategory = currentEvent?.skills?.[0]?.name ?? "";
       // Check if the course is published more than 30 days ago
       const datePublished = new Date(currentEvent?.datePublished);
       const currentDate = new Date();
       const dateDiff = Math.floor((currentDate - datePublished) / (1000 * 60 * 60 * 24)); // Difference in days
       const isNewlyAdded = dateDiff <= 30 ? "yes" : "no";
        pageLoad_Started(currentEvent?.title, window.location.origin + localStorage.getItem('prevUrl'), filteredTopics,isNewlyAdded,true,event_skill_levelCategory,
        level,admissionCost,isConententCategory);
         pageLoadCompleted();
          window.scrollTo({ top: 0 });
      }, []);

      const getPaidStatus =(cost)=>{
          const costStr = cost != null ? String(cost).trim().toLocaleLowerCase() : "";
          if(!costStr || costStr ==="free" || costStr === "0") return t("free");
          if(costStr === "paid") return t("paid");
          const numeric = parseFloat(costStr?.replace(/[^0-9.]/g, ""));
          if(!isNaN(numeric) && numeric > 0) return t("paid");
          return t("free");
      }

  let videoLength = 0;
  currentEvent?.modules?.forEach((module) => {
    if (module.format?.toLowerCase() === 'video' || module.title?.toLowerCase() === 'interactive video') {
      videoLength += module.duration || 0;
    }
  });
  const formattedVideoLength = formatTime(videoLength);
  const hasVideo = currentEvent?.modules?.some((module) => module?.format?.toLowerCase() === "video" || module?.title?.toLowerCase() === "interactive video") && videoLength > 0;

  return (
    <div>
      <Grid bleed="1232" colSizes={{
        mobile: 4,
        tablet: 12,
        desktop: 12,
      }}>
        <Row>
          <Col>
            <EventDetailsHeader  currentInPersonEvent={currentInPersonEvent} isInPersonEvent={isInPersonEvent} hasVideo={hasVideo} formattedVideoLength={formattedVideoLength} isRecorded={isRecorded} currentEvent={currentEvent} eventCxAemData={eventCxAemData} headerIcons={headerIcons} topicEnEsMaping={topicEnEsMaping} />
          </Col>
        </Row>
        <Row>
          <Col>
            {allCourses && allQuickTips && allEventsWithTimeZone && allIPEventsWithTimezone && <div className='mt-12X sm-mt-8X course_details_body'>
              <EventDetailsBody isInPersonEvent={isInPersonEvent} currentInPersonEvent={currentInPersonEvent} formattedCurrentEvent={formattedCurrentEvent} aemOffersContentForHeading={aemOffersContentForHeading} selectedTopics={selectedTopics} topicEnEsMaping={topicEnEsMaping} currentCourse={currentEvent} courseType={courseType} eventCxAemData={eventCxAemData} allQuickTips={allQuickTips} allCourses={allCourses} allIPEventsWithTimezone={allIPEventsWithTimezone} allEventsWithTimeZone={allEventsWithTimeZone} offersMock={offersMock} eventStatus={eventStatus} isRecorded={isRecorded} />
            </div>}
          </Col>
        </Row>
      </Grid>
      {!isEnrollmentDeadlinePassed && !isEventEnded && !isInPersonEvent && (
      <div className='course_details_footer'>
        <div className='course_details_footer_content'>
          <div className='title-sm' id='reg-banner-text'></div>
          <div className='button-grp'>
            <ButtonGroup
              data={[
                {
                  children: eventCxAemData?.regBannerButtons?.regButtonText,
                  size: 'large',
                  use: 'primary',
                  width: 'fit-content',
                  onClick: () => {
                      let updatedTopics = mapTopicsAndTags(currentEvent,eventCxAemData);
                      contentClick(courseTitleEnEs,window.location.href,updatedTopics,'event_page_sticky_register')},
                  href: eventCxAemData?.regBannerButtons?.regLink
                },
                {
                  children: eventCxAemData?.regBannerButtons?.signInText,
                  size: 'large',
                  use: 'textLink',
                  width: 'fit-content',
                  href: signInLinkMod
                },
              ]}
            />
          </div>
        </div>
      </div>
      )}
      {isInPersonEvent && !isEnrollmentDeadlinePassed && !isEventEnded && (
      <div className='course_details_footer'>
        <div className='course_details_footer_content'>
          <div className='title-sm' id='reg-banner-text'></div>
          <div className='button-grp'>
            <ButtonGroup
              data={[
                {
                  children: eventCxAemData?.regBannerButtons?.regButtonText,
                  size: 'large',
                  use: 'primary',
                  width: 'fit-content',
                  onClick: () => {
                      let updatedTopics = mapTopicsAndTags(currentEvent?.tags,topicEnEsMaping,eventCxAemData);
                      contentClick(currentEvent?.title,window.location.href,updatedTopics,'InPersonevent_page_sticky_register')},
                  href: eventCxAemData?.regBannerButtons?.regLink
                },
                {
                  children: eventCxAemData?.regBannerButtons?.signInText,
                  size: 'large',
                  use: 'textLink',
                  width: 'fit-content',
                  onClick: () => {
                    Register_Event(
                      courseTitleEnEs,skillCategory,skillLvl,formattedAdmissionCost,`${t("Event")}: ${t("In-Person Event")}`);},
                  href: signInLinkMod
                },
              ]}
            />
          </div>
        </div>
      </div>
      )}
    </div>
  )
}

export default EventDetailsPage